import React from "react";

const RenderHTML = ({ children = "", className = "" }) => (
  <div className={className} dangerouslySetInnerHTML={{ __html: children.replace(/\n/g, "<br />") }} />
);

export default RenderHTML;
